module.exports = __webpack_public_path__ + "static/media/airbnb.34d4e16a.jpg";